import { render, staticRenderFns } from "./DocumentNotificationDialog.vue?vue&type=template&id=26f7e30a"
import script from "./DocumentNotificationDialog.vue?vue&type=script&lang=js"
export * from "./DocumentNotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports